import { takeLatest, takeEvery, fork, put, all, call } from 'redux-saga/effects'

import i18n from 'i18n'
import { usersAPI } from 'features/users/api'
import { mentorMentorsList } from './slice'
import { RequestUtils } from 'utils'
import { authLogoutPA } from 'features/auth/store'

function* getList({ payload: { params } }) {
  try {
    let requestParams = {
      for_job: params?.for_job,
      includes: ['studentProfile', 'avatar'],
    }

    requestParams = RequestUtils.getMapRequestParams(params, requestParams)

    const response = yield call(usersAPI.getMentors, requestParams)

    const { data } = response

    const {
      meta: { current_page, last_page },
    } = data

    if (current_page && last_page && current_page > last_page) {
      yield put(
        mentorMentorsList.getList({
          params: {
            ...params,
            page: last_page,
          },
        })
      )
    } else {
      yield put(mentorMentorsList.getListSuccess(data))
    }
  } catch (error) {
    const message = error.response?.data?.message || i18n.t('error')
    yield put(mentorMentorsList.getListError(message))
  }
}

function* watchGetList() {
  yield takeLatest(mentorMentorsList.getList, getList)
}

function* cleanState() {
  yield put(mentorMentorsList.cleanState({}))
}

function* watchUserLogout() {
  yield takeEvery(authLogoutPA.success, cleanState)
}

export function* listSaga() {
  yield all([fork(watchGetList), fork(watchUserLogout)])
}
